import Breadcrumbs from 'shared/ui/Breadcrumbs'
import { PATHS } from 'shared/utils/paths'

import { SectionContainer } from '../landings/styles'

const QualityGuaranteeBreadcrumbs = () => {
  return (
    <SectionContainer as='div'>
      <Breadcrumbs
        breadcrumbs={[
          { label: 'Strona główna', path: PATHS.home },
          { label: 'Jakość Lokalnego Rolnika', path: PATHS.quality }
        ]}
      />
    </SectionContainer>
  )
}

export default QualityGuaranteeBreadcrumbs
